import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { useHubAgenda } from '../../../store/hub/useHubAgenda';
import { useQueryParam } from 'use-query-params';
import { useMemo } from 'react';

import CountUp from "react-countup";
import { getDay } from '../../../services/functions';

export function Agendamentos() {
  const [active] = useQueryParam("date");

  const agendaDetails = useHubAgenda(state => state.data.details[getDay(active).format('YYYY-MM-DD')
  ])

  const agendamentos = useMemo(() => {
    const agendados = agendaDetails?.agendado || 0
    const emAndamento = agendaDetails?.emAndamento || 0
    const finalizados = agendaDetails?.orcamentoEnviado || 0
    const total = _.sum([agendados, emAndamento, finalizados]);

    const data = { total, agendados, emAndamento, finalizados, }

    const chart = [{
      name: 'Agendamentos',
      'Agendados': agendados,
      'Em Andamento': emAndamento,
      'Finalizados': finalizados,
    }]

    return { chart, data }
  }, [agendaDetails])

  return (
    <div className="w-full h-full max-h-52 lg:max-h-40 xl:max-h-64 flex gap-8" >
      <div className="w-full h-full flex-1 -ml-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={agendamentos.chart} style={{ fontSize: 12 }}>
            <XAxis dataKey="name" stroke='#888' axisLine={false} tickLine={false} />
            <YAxis stroke='#888' axisLine={false} tickLine={false} />
            <Tooltip />
            <Legend verticalAlign="top" height={36} />
            <CartesianGrid vertical={false} className='stroke-zinc-300/50' />
            <Bar dataKey="Agendados" fill={"#00a1a4"} barSize={30} />
            <Bar dataKey="Finalizados" fill={"#59602c"} barSize={30} />
            <Bar dataKey="Em Andamento" fill={'#c64d21'} barSize={30} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="flex flex-col h-full gap-2 text-xs font-light justify-center items-end pr-2">
        <p>Agendados: <strong className="font-semibold inline-block w-6">
          <CountUp
            end={agendamentos.data.agendados ?? 0}
            preserveValue
            useEasing
          />
        </strong></p>
        <p>Finalizados: <strong className="font-semibold inline-block w-6">
          <CountUp
            end={agendamentos.data.finalizados ?? 0}
            preserveValue
            useEasing
          />
        </strong></p>
        <p>Em Andamento: <strong className="font-semibold inline-block w-6">
          <CountUp
            end={agendamentos.data.emAndamento ?? 0}
            preserveValue
            useEasing
          />
        </strong></p>
        <p>Total: <strong className="font-semibold inline-block w-6">
          <CountUp
            end={agendamentos.data.total ?? 0}
            preserveValue
            useEasing
          />
        </strong></p>
      </div>
    </div >
  );
}
